import { useEffect, useState } from 'react'
import Modal from '../../UI/Modal/Modal'
import { initSpinDuration } from '../../UI/Cube/Cube'
import props from '../../../redux/props'
import { useSelector } from 'react-redux'
import Countdown from './Countdown'

const Popup = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [isVisible, setIsVisible] = useState(false)

  const toggle = () => setIsVisible(!isVisible)

  useEffect(() => {
    const popupParam = new URL(window.location.href).searchParams.get('popup')
    const showPopup = !popupParam
    if (showPopup) {
      setTimeout(() => {
        setIsVisible(true)
        setIsVisible(true)
        const url = new URL(window.location.href)
        url.searchParams.set('popup', 'false')
        window.history.pushState({}, '', url)
      }, initSpinDuration * 1100)
    }
  }, [])

  return (
    <Modal noForm show={isVisible} closeIcon onClose={toggle}>
      <div className="text-white font-bolder text-4xl leading-[2.75rem] w-[90%]">{t.cubePopup.countdownPrefix}</div>
      <div className="mt-14 mb-10">
        <Countdown />
      </div>
      <a href="/newsalarm" className="text-white underline font-bolder mt-3 block">
        {t.cubePopup.newsalarmLinkLabel}
      </a>
      {/* <a
        className="text-white pt-3 font-bolder block underline"
        target="_blank"
        rel="noreferrer"
        href="https://album.spd.de/pressarea-modern/ufX5DtucVXGUQSBQ6zaLMV"
      >
        {t.cubePopup.pressLinkLabel}
      </a> */}
    </Modal>
  )
}

export default Popup
